export enum BusinessTypeEnum {
  TERMINAL = 'terminal',
  ORGANISATION = 'organisation',
  CCC = 'ccc',
}
